import React from "react";

export default function SplashLoading() {
  return <div className="splash-loader"></div>;
}
